import {Box, LinkButton, Modal, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {FC} from 'react'

import * as classes from './BusinessModal@desktop.classes'
import {useBusinessBannerModal} from './hooks'
import type {BusinessModalProps} from './types'

const BusinessModal: FC<BusinessModalProps> = props => {
  const {isActive, setActive, utm_source} = props
  const i18n = useI18n()
  const {title, list, description, imageSrc, link, handleRegisterLinkClick, handleClose} = useBusinessBannerModal(
    setActive,
    utm_source,
  )

  return (
    <Modal className={classes.modal} onClose={handleClose} opened={isActive}>
      <Modal.Header
        pb="s"
        pl="l"
        pr="xl"
        pt="xl"
        renderTitle={(a11yProps, typographyProps) => (
          <Typography color="invert" group="loose" id={a11yProps.id} mt="s" thickness="bold" variant="title2">
            {typographyProps.children}
          </Typography>
        )}
        title={title}
      />
      <Modal.Body className={classes.body} px="l">
        <Typography color="invert" group="loose" variant="body1">
          {description}
        </Typography>
        {list.length > 0 ? (
          <Typography color="invert" group="loose" ml="xl" mt="m" variant="body1">
            <ul>
              {list.map((text, i) => (
                <li key={i}>{text}</li>
              ))}
            </ul>
          </Typography>
        ) : null}
        <Box className={classes.image} mt="m" style={{backgroundImage: `url(${imageSrc})`}} />
      </Modal.Body>
      <Modal.Footer className={classes.footer} p="s">
        <LinkButton href={link} onPress={handleRegisterLinkClick} variant="floating" fullWidth>
          {i18n('order.banner.button.register', 'Зарегистрироваться')}
        </LinkButton>
      </Modal.Footer>
    </Modal>
  )
}

BusinessModal.displayName = 'Business_Modal'

export {BusinessModal}
